export enum DeclarationExternalEntity {
    CDS = 'CDS',
    CHIEF = 'CHIEF',
    REVENUE = 'REVENUE',
    GVMS = 'GVMS',
    HMRC = 'HMRC',
    ICS2 = 'ICS2',
}

export const declarationExternalEntityLabelMap: Record<DeclarationExternalEntity, string> = {
    [DeclarationExternalEntity.REVENUE]: 'Ireland',
    [DeclarationExternalEntity.HMRC]: 'UK',
    [DeclarationExternalEntity.CDS]: 'UK',
    [DeclarationExternalEntity.CHIEF]: 'UK',
    [DeclarationExternalEntity.GVMS]: 'UK',
    [DeclarationExternalEntity.ICS2]: 'ICS2',
};
